module.exports = __webpack_public_path__ + "img/BAequipmentManage.9dd56fa9.svg";